import React from "react";
import { Controller, Control, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ComboboxInput from "../../../components/inputs/ComboboxInput";
import TextInput from "../../../components/inputs/TextInput";
import { StartEvacuationFormData } from "../../../schemas/startEvacuationSchema";

interface ScopeSectionProps {
  control: Control<StartEvacuationFormData>;
  errors: FieldErrors<StartEvacuationFormData>;
  locations: any[];
  buildings: any[];
  setValue: (name: keyof StartEvacuationFormData, value: string) => void;
  clearMusterPoints: () => void;
  disabled?: boolean;
}

const ScopeSection: React.FC<ScopeSectionProps> = ({
  control,
  errors,
  locations,
  buildings,
  setValue,
  clearMusterPoints,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <p>
        {t("1")}. {t("selectScope")}
      </p>

      <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-3 lg:gap-6">
        <Controller
          name="location"
          control={control}
          render={({ field: { onChange, name, value } }) => (
            <ComboboxInput
              options={locations}
              value={
                value
                  ? locations?.find((item) => item.value === Number(value))
                      ?.labelEn || ""
                  : ""
              }
              onChange={(value) => {
                onChange(value);
                setValue("building", "");
                clearMusterPoints();
              }}
              error={errors?.[name]?.message}
              label={t("location")}
              required
              readOnly={disabled}
            />
          )}
        />

        <Controller
          name="building"
          control={control}
          render={({ field: { onChange, name, value } }) => (
            <ComboboxInput
              options={buildings}
              value={
                buildings?.find((item) => item.value === Number(value))
                  ?.labelEn || ""
              }
              onChange={(value) => {
                onChange(value);
                clearMusterPoints();
              }}
              error={errors?.[name]?.message}
              label={t("building")}
              readOnly={disabled}
            />
          )}
        />

        <Controller
          name="floor"
          control={control}
          render={({ field: { onChange, name, value } }) => (
            <TextInput
              label={t("floor")}
              onChange={onChange}
              value={value || ""}
              error={errors?.[name]?.message}
              readOnly={disabled}
            />
          )}
        />
      </div>
    </div>
  );
};

export default ScopeSection;
